import ChangeHighglightedImmutableUnderReviewDropdown from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighglightedImmutableUnderReviewDropdown';
import React from 'react';
export default function ItemTypeDropdown(_ref) {
  let {
    claim,
    claimConsumable,
    userUnauthorizedToEdit,
    onChange,
    onBlur
  } = _ref;
  const valuesArray = [{
    id: 'Consumables',
    name: 'Materials'
  }, {
    id: 'Utilities',
    name: 'Utilities'
  }];
  return /*#__PURE__*/React.createElement(ChangeHighglightedImmutableUnderReviewDropdown, {
    claim: claim,
    valuesArray: valuesArray,
    edittedObject: claimConsumable,
    edittedObjectFieldName: 'item_type',
    userUnauthorizedToEdit: userUnauthorizedToEdit,
    onChange: onChange,
    onBlur: onBlur,
    onCreate: false
  });
}